module.exports = __webpack_public_path__ + "img/99diy.2c62bcbd.svg";